import { PropsWithChildren } from "react";
import { Map as GoogleMap } from "@vis.gl/react-google-maps";

const Map: React.FC<PropsWithChildren> = (props) => {
  const { children } = props;

  return (
    <GoogleMap
      mapId="c12d949c6b96b4b4d43b151f"
      defaultCenter={{ lat: 62.848100869447016, lng: 16.481233077063187 }}
      defaultZoom={5}
      maxZoom={20}
      mapTypeControl={false}
      streetViewControl={false}
      disableDefaultUI={true}
      clickableIcons={false}
    >
      {children}
    </GoogleMap>
  );
};

export default Map;
